/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as callActions from "../../actions/callActions";
import * as codeActions from "../../actions/codeActions";

import { addHoursToDate } from "../../helpers/date";

import HolidayForm from "./HolidayForm";
import CustomerService from "../../services/customerService";
import ProjectService from "../../services/projectService";
import serviceService from "../../services/serviceService";
import UserService from "../../services/userService";
import Loading from "../common/Loading";
import Checkbox from "../common/Checkbox";

const HolidayPage = ({ codes, actions, auth }) => {
  const [inputs, setInputs] = useState({
    fixed_time: true,
    off_hours: false,
    actual_hrs: 8
  });
  const [loading, setLoading] = useState(false);
  const [defaultData, setDefaultData] = useState({});
  const [saving, setSaving] = useState(false);
  const [users, setUsers] = useState([]);
  const [displayUsers, setDisplayUsers] = useState(false);
  const [individualHoliday, setIndividualHoliday] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  const handleCheck = (value, cell) => {
    setSelectedUsers((prev) => {
      if (prev.find((user) => user.id === cell.id)) {
        return prev.filter((user) => user.id !== cell.id);
      }
      return [...prev, cell];
    });
  };
  const mainColumns = [
    {
      Header: "Name",
      accessor: "full_name",
      id: "full_name"
    },
    {
      Header: "Tech Id",
      accessor: "tech_id",
      id: "tech_id"
    },
    {
      Header: "Email",
      accessor: "email",
      id: "email"
    },
    {
      Header: "Department",
      accessor: "department.description",
      id: "department"
    }
  ];
  const columns = useMemo(
    () => [
      {
        Header: "Select",
        accessor: "select",
        Cell: ({ original }) => (
          <Checkbox
            checked={!!selectedUsers.find((user) => user.id === original.id)}
            style={{ margin: 0 }}
            onClickCheck={(e) => handleCheck(e.target.checked, original)}
          />
        )
      },
      ...mainColumns
    ],
    [handleCheck, selectedUsers, mainColumns]
  );

  const getFilteredUsers = useCallback(
    (usersData) =>
      usersData.filter((user) => {
        if (user.termination_date) {
          if (
            new Date(user.termination_date).setUTCHours(13) >=
            new Date(inputs.arrival_date).setUTCHours(13)
          ) {
            return user;
          }
          return;
        }
        return user;
      }),
    [inputs]
  );

  useEffect(() => {
    if (!inputs?.customer && !loading) {
      const fetchCustomers = async () => {
        setLoading(true);
        const customers = await CustomerService.findByNumber("GRAVOCAS01");
        setInputs((prev) => ({
          ...prev,
          customer: customers[0]._id
        }));
        setDefaultData((prev) => ({
          ...prev,
          customers: [customers[0]]
        }));
        setLoading(false);
      };
      fetchCustomers();
    }
  }, [inputs, loading]);

  useEffect(() => {
    if (!inputs?.project) {
      const fetchProjects = async () => {
        setLoading(true);
        const projects = await ProjectService.findByNumber("GRAVOCASSO-0076");
        if (projects?.length > 0) {
          setInputs((prev) => ({
            ...prev,
            project: projects[0]._id
          }));
          setDefaultData((prev) => ({
            ...prev,
            projects: [projects[0]]
          }));
        }
        setLoading(false);
      };
      fetchProjects();
    }
  }, [inputs]);

  useEffect(() => {
    if (!inputs?.service && !loading) {
      const fetchServices = async () => {
        setLoading(true);
        const services = await serviceService.findByCode(985);
        setInputs((prev) => ({
          ...prev,
          service: services[0]._id
        }));
        setDefaultData((prev) => ({
          ...prev,
          services: [services[0]]
        }));
        setLoading(false);
      };
      fetchServices();
    }
  }, [inputs, loading]);

  useEffect(() => {
    if (!inputs?.call_type && codes.length > 0) {
      const call_type = codes?.find(
        (c) =>
          c.entity === "Call" && c.field === "type" && c.label === "PERSONAL"
      );
      setInputs((prev) => ({
        ...prev,
        call_type: call_type._id
      }));
      setDefaultData((prev) => ({
        ...prev,
        call_types: [call_type]
      }));
    }
    if (!inputs?.stage && codes.length > 0) {
      const stage = codes?.find(
        (c) =>
          c.entity === "Call" && c.field === "status" && c.label === "Completed"
      );
      setInputs((prev) => ({
        ...prev,
        stage: stage._id
      }));
      setDefaultData((prev) => ({
        ...prev,
        stages: [stage]
      }));
    }
    if (!inputs?.status && codes.length > 0) {
      const status = codes?.filter(
        (c) => c.entity === "Tech" && c.field === "employment_status"
      );
      const salaryStatus = status.find((s) => s.label === "Salary");
      setInputs((prev) => ({
        ...prev,
        status: [
          {
            value: salaryStatus._id,
            label: salaryStatus.label
          }
        ]
      }));
      setDefaultData((prev) => ({
        ...prev,
        status
      }));
    }
  }, [codes, inputs]);

  useEffect(() => {
    if (displayUsers) {
      const fetchUsers = async () => {
        setLoading(true);
        const body = queryString.stringify(
          {
            employment_status: inputs.status.map((s) => s.value)
          },
          {
            arrayFormat: "bracket"
          }
        );
        const userResult = await UserService.getUsersByStatus(body);
        const usersToSet = inputs.arrival_date
          ? getFilteredUsers(userResult)
          : userResult;
        setUsers(usersToSet);
        setLoading(false);
      };
      fetchUsers();
    }
  }, [displayUsers, inputs.status]);

  useEffect(() => {
    if (individualHoliday) {
      const fetchUsers = async () => {
        setLoading(true);
        const user = await UserService.loadUsers();
        const usersToSet = inputs.arrival_date ? getFilteredUsers(user) : user;
        setUsers(usersToSet);
        setLoading(false);
      };
      fetchUsers();
    }
  }, [individualHoliday]);

  const onChange = (field, data) => {
    setInputs((prev) => ({
      ...prev,
      [field]: data
    }));
  };

  const onChangeDate = (date, name) => {
    const hours = 8;
    const completed_date = addHoursToDate(date, hours);
    setInputs((prev) => ({
      ...prev,
      [name]: date,
      completed_date
    }));
  };

  const onSubmit = async () => {
    setSaving(true);
    if (individualHoliday) {
      await actions.createIndividualHoliday(
        inputs,
        selectedUsers.map((u) => ({ value: u._id }))
      );
    } else {
      await actions.createHoliday(inputs);
    }
    setSaving(false);
    setInputs((prev) => ({
      ...prev,
      arrival_date: null,
      completed_date: null,
      internal_notes: "",
      billing_description: ""
    }));
    setIndividualHoliday(false);
    setSelectedUsers([]);
  };

  const usersToggle = () => {
    setDisplayUsers(!displayUsers);
  };

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <HolidayForm
          inputs={inputs}
          onChange={onChange}
          defaultData={defaultData}
          onChangeDate={onChangeDate}
          onSubmit={onSubmit}
          saving={saving}
          usersToggle={usersToggle}
          displayUsers={displayUsers}
          individualHoliday={individualHoliday}
          toggleIndividualHoliday={setIndividualHoliday}
          auth={auth}
          selectedUsers={selectedUsers}
        />
        {displayUsers && !individualHoliday && users && (
          <ReactTable
            className="-highlight"
            data={users}
            resizable
            loading={loading}
            LoadingComponent={() => <Loading active={loading} />}
            columns={mainColumns}
            defaultPageSize={10}
            defaultSorted={[
              {
                id: "full_name",
                desc: false
              }
            ]}
          />
        )}
        {individualHoliday && users && (
          <ReactTable
            className="-highlight"
            data={users}
            resizable
            loading={loading}
            LoadingComponent={() => <Loading active={loading} />}
            columns={columns}
            defaultPageSize={10}
            defaultSorted={[
              {
                id: "full_name",
                desc: false
              }
            ]}
          />
        )}
      </div>
    </React.Fragment>
  );
};
HolidayPage.propTypes = {
  auth: PropTypes.object,
  codes: PropTypes.array,
  actions: PropTypes.object
};
function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth,
    codes: state.reducers.codes
  };
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...codeActions,
      ...callActions
    },
    dispatch
  )
});

export default connect(mapStatesToProps, mapDispatchToProps)(HolidayPage);
